import { defineComponent as _defineComponent } from 'vue'
import {
  ApprovalOvertimeWorkUser,
  ApprovalShift
} from "@/models/approval/ApprovalResponse";
import { DateTime } from "luxon";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "../table/ApprovalChip.vue";
import TimeList from "@/components/list/TimeList.vue";
import { OverworkFlowDat } from "@/models/transaction/OverworkFlowDat";

type Props = {
  dat: OverworkFlowDat;
  approvals: ApprovalOvertimeWorkUser[];
  shift: ApprovalShift;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'OverworkExpandItem',
  props: {
    dat: null,
    approvals: null,
    shift: null
  },
  setup(__props: any) {

const shiftHeader = [
  { text: "開始時間： ", value: "startTime" },
  { text: "終了時間： ", value: "endTime" },
  { text: "総休憩時間： ", value: "breakTime" },
  { text: "深夜休憩時間： ", value: "midnightBreakTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDate = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};



return { __sfc: true,shiftHeader, approvalHeaders, formatDate, ApprovalChip, TimeList }
}

})